export type VendiaProduct = "master" | "quote" | "pos" | "business";

export type VendiaLogoVariant = "horizontal" | "stacked" | "mono" | "dark";

type ProductAssetSet = {
  logo: {
    horizontal: string;
    stacked: string;
    mono?: string;
    dark?: string;
  };
  icon: {
    color: string;
    dark?: string;
  };
  appIcon: string;
};

export const vendiaAssetPaths: Record<VendiaProduct, ProductAssetSet> = {
  master: {
    logo: {
      horizontal: "assets/svg/logos/vendia-master-logo-horizontal.svg",
      stacked: "assets/svg/logos/vendia-master-logo-stacked.svg",
      mono: "assets/svg/monochrome/vendia-master-logo-mono.svg",
      dark: "assets/svg/dark-mode/vendia-master-logo-dark.svg",
    },
    icon: {
      color: "assets/svg/icons/vendia-master-icon-color.svg",
    },
    appIcon: "assets/svg/app-icons/vendia-master-app-icon.svg",
  },
  quote: {
    logo: {
      horizontal: "assets/svg/logos/vendia-quote-logo-horizontal.svg",
      stacked: "assets/svg/logos/vendia-quote-logo-stacked.svg",
      mono: "assets/svg/monochrome/vendia-quote-logo-mono.svg",
    },
    icon: {
      color: "assets/svg/icons/vendia-quote-icon-color.svg",
      dark: "assets/svg/dark-mode/vendia-quote-icon-dark.svg",
    },
    appIcon: "assets/svg/app-icons/vendia-quote-app-icon.svg",
  },
  pos: {
    logo: {
      horizontal: "assets/svg/logos/vendia-pos-logo-horizontal.svg",
      stacked: "assets/svg/logos/vendia-pos-logo-stacked.svg",
      mono: "assets/svg/monochrome/vendia-pos-logo-mono.svg",
    },
    icon: {
      color: "assets/svg/icons/vendia-pos-icon-color.svg",
      dark: "assets/svg/dark-mode/vendia-pos-icon-dark.svg",
    },
    appIcon: "assets/svg/app-icons/vendia-pos-app-icon.svg",
  },
  business: {
    logo: {
      horizontal: "assets/svg/logos/vendia-business-logo-horizontal.svg",
      stacked: "assets/svg/logos/vendia-business-logo-stacked.svg",
      mono: "assets/svg/monochrome/vendia-business-logo-mono.svg",
    },
    icon: {
      color: "assets/svg/icons/vendia-business-icon-color.svg",
      dark: "assets/svg/dark-mode/vendia-business-icon-dark.svg",
    },
    appIcon: "assets/svg/app-icons/vendia-business-app-icon.svg",
  },
};

export function resolveVendiaAssetPath(path: string, assetBasePath = "") {
  if (!assetBasePath) {
    return path;
  }

  return `${assetBasePath.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}
